import { DateTime } from 'luxon';

import TimeGranularity from '@/common/enums/time-granularity.enum';

const getDateFormatByTimeGranularity = (granularity) => {
  switch (granularity) {
    case TimeGranularity.HOURLY:
      return DateTime.DATETIME_MED;
    case TimeGranularity.DAILY:
      return DateTime.DATE_SHORT;
    case TimeGranularity.MONTHLY:
      return 'LLL yyyy';
    case TimeGranularity.YEARLY:
      return 'yyyy';
    default:
      return DateTime.DATETIME_MED;
  }
};

const getOptionsAvailableByGranularity = (granularity) => {
  switch (granularity) {
    case TimeGranularity.HOURLY:
      return [TimeGranularity.HOURLY, TimeGranularity.DAILY, TimeGranularity.MONTHLY, TimeGranularity.YEARLY];
    case TimeGranularity.DAILY:
      return [TimeGranularity.DAILY, TimeGranularity.MONTHLY, TimeGranularity.YEARLY];
    case TimeGranularity.MONTHLY:
      return [TimeGranularity.MONTHLY, TimeGranularity.YEARLY];
    case TimeGranularity.YEARLY:
      return [TimeGranularity.YEARLY];
    default:
      return Object.values(TimeGranularity);
  }
};

const DateFormatUtils = {
  getDateFormatByTimeGranularity,
  getOptionsAvailableByGranularity,
};

export default DateFormatUtils;
